/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import { getQueryParameterFromUrl } from "dc-preview-utils/src/Utils/UrlUtils";
import { isCurrentDeviceMobile, isCurrentDeviceTablet } from "dc-preview-utils/src/Utils/DeviceUtils";
import { getFileExtension, viewDocumentProperties } from "selectors/documentSelectors";
import * as stores from "stores";

export const shouldShowDocumentProperties = () => {
  const fileExtension = getFileExtension(stores);
  const isPDF = fileExtension.toLowerCase() === "pdf";
  return (
    getQueryParameterFromUrl(window.location.href, "viewDocumentProperties") !== "false" &&
    viewDocumentProperties(stores) &&
    !isCurrentDeviceMobile() &&
    !isCurrentDeviceTablet() &&
    isPDF
  );
};
